import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import FooterSection from './FooterSection';
import './EnquiryPage.css';

export default function EnquiryPage() {
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [alert, setAlert] = useState({ type: '', message: '' });

  const [formData, setFormData] = useState({
    studentName: '',
    emailAddress: '',
    mobileNumber: '',
    alternativeMobileNumber: '',
    highestQualification: 'Graduate (UG)',
    state: 'Andhra Pradesh',
    city: '',
    programInterested: '',
    isWorkingProfessional: 'No',
    additionalMessage: ''
  });

  const indianStates = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
    'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
    'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
    'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
    'Delhi', 'Puducherry', 'Jammu & Kashmir'
  ];

  const qualifications = [
    '10th Pass',
    '10+2 / Higher Secondary',
    'Diploma',
    'Graduate (UG)',
    'Post Graduate (PG)',
    'Doctorate / Ph.D.'
  ];

  // Fetch courses from GET API
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await fetch('https://metapi.emedhatechnologies.com/api/courses/courses');
        const data = await res.json();
        if (data.success && data.data.length > 0) {
          setCourses(data.data);
          setFormData((prev) => ({ ...prev, programInterested: data.data[0].course_name }));
        }
      } catch (err) {
        console.error('Failed to load courses:', err);
      } finally {
        setLoadingCourses(false);
      }
    };
    fetchCourses();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlert({ type: '', message: '' });
    setSubmitting(true);

    try {
      const res = await fetch('https://metapi.emedhatechnologies.com/api/students/enquiry/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await res.json();

      if (data.success) {
        setAlert({ type: 'success', message: data.message });
        setFormData({
          studentName: '',
          emailAddress: '',
          mobileNumber: '',
          alternativeMobileNumber: '',
          highestQualification: 'Graduate (UG)',
          state: 'Andhra Pradesh',
          city: '',
          programInterested: courses[0]?.course_name || '',
          isWorkingProfessional: 'No',
          additionalMessage: ''
        });
      } else {
        setAlert({ type: 'error', message: data.message || 'Submission failed.' });
      }
    } catch (err) {
      console.error('Enquiry Error:', err);
      setAlert({ type: 'error', message: 'Server error. Please try again later.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="enquiry-page-wrapper">
        
        {/* Header Banner */}
        <section className="enquiry-hero-banner">
          <div className="banner-inner-container">
            <nav className="breadcrumb-nav">
              <Link to="/" className="breadcrumb-link">Home</Link> / <span> Enquiry</span>
            </nav>
            <h1>Enquiry</h1>
            <p>Reach out to CDOE, EDULEARNER — we are here to help you.</p>
          </div>
        </section>

        {/* Form Container */}
        <section className="enquiry-form-section">
          <div className="enquiry-container">
            
            <div className="enquiry-card-wrapper">
              
              {/* Card Header Banner */}
              <div className="card-header-blue">
                <h2>Admission Enquiry Form – AY 2025–26</h2>
                <p>Our team will respond within 24 working hours</p>
              </div>

              {/* Form Body */}
              <form onSubmit={handleSubmit} className="enquiry-form-grid">
                
                {alert.message && (
                  <div className={`form-alert-box ${alert.type}`}>
                    {alert.message}
                  </div>
                )}

                <div className="form-row-2col">
                  {/* Student Name */}
                  <div className="field-group">
                    <label>Student Name *</label>
                    <input
                      type="text"
                      name="studentName"
                      placeholder="Full name"
                      value={formData.studentName}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Email Address */}
                  <div className="field-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      name="emailAddress"
                      placeholder="your@email.com"
                      value={formData.emailAddress}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-row-2col">
                  {/* Mobile Number */}
                  <div className="field-group">
                    <label>Mobile Number *</label>
                    <input
                      type="tel"
                      name="mobileNumber"
                      placeholder="+91 XXXXX XXXXX"
                      value={formData.mobileNumber}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="field-group">
                        <label>Alternative Mobile Number</label>
                        <input
                          type="tel"
                          name="alternativeMobileNumber"
                          placeholder="+91 XXXXX XXXXX (Optional)"
                          value={formData.alternativeMobileNumber}
                          onChange={handleChange}
                        />
                      </div>

                  {/* Highest Qualification */}
                  <div className="field-group">
                    <label>Highest Qualification *</label>
                    <select
                      name="highestQualification"
                      value={formData.highestQualification}
                      onChange={handleChange}
                      required
                    >
                      {qualifications.map((q, idx) => (
                        <option key={idx} value={q}>{q}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row-2col">
                  {/* State */}
                  <div className="field-group">
                    <label>State *</label>
                    <select
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      required
                    >
                      {indianStates.map((st, idx) => (
                        <option key={idx} value={st}>{st}</option>
                      ))}
                    </select>
                  </div>

                  {/* City */}
                  <div className="field-group">
                    <label>City</label>
                    <input
                      type="text"
                      name="city"
                      placeholder="Your city"
                      value={formData.city}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-row-2col">
                  {/* Program Interested In */}
                  <div className="field-group">
                    <label>Program Interested In *</label>
                    <select
                      name="programInterested"
                      value={formData.programInterested}
                      onChange={handleChange}
                      required
                      disabled={loadingCourses}
                    >
                      {loadingCourses ? (
                        <option>Loading courses...</option>
                      ) : (
                        courses.map((course) => (
                          <option key={course.id} value={course.course_name}>
                            {course.course_name}
                          </option>
                        ))
                      )}
                    </select>
                  </div>

                  {/* Working Professional */}
                  <div className="field-group">
                    <label>Working Professional?</label>
                    <select
                      name="isWorkingProfessional"
                      value={formData.isWorkingProfessional}
                      onChange={handleChange}
                    >
                      <option value="No">No</option>
                      <option value="Yes">Yes</option>
                    </select>
                  </div>
                </div>

                {/* Additional Message */}
                <div className="field-group full-width">
                  <label>Additional Message</label>
                  <textarea
                    name="additionalMessage"
                    rows="3"
                    placeholder="Any specific questions..."
                    value={formData.additionalMessage}
                    onChange={handleChange}
                  ></textarea>
                </div>

                {/* Submit Button */}
                <div className="form-actions-row">
                  <button type="submit" className="btn-submit-enquiry" disabled={submitting}>
                    <span className="send-icon">✈</span> {submitting ? 'Submitting...' : 'Submit Enquiry'}
                  </button>
                </div>

              </form>

            </div>

          </div>
        </section>

      </div>
      <FooterSection />
    </>
  );
}